import { Typography } from "@mui/material";
import type { NumberObjectFilter } from "../../api/types/objectTypes";
import { getNumberFilterValuesText, numberFilterOperatorCaptions } from "./objectFilterHelpers";

interface Props {
  fieldName: string;
  filter: NumberObjectFilter;
  startLabel: string;
}

const ObjectNumberFilterDescription = ({ fieldName, filter, startLabel }: Props) => {
  return (
    <Typography>
      {startLabel} <strong>{fieldName}</strong> {numberFilterOperatorCaptions[filter.operator] ?? filter.operator}{" "}
      <strong>{getNumberFilterValuesText(filter)}</strong>
    </Typography>
  );
};

export default ObjectNumberFilterDescription;
